import React from "react";
import "./DashboardPage.css";

export default function Settings() {
  return (
    <div className="dashboard-page">
      <h2>Ayarlar</h2>
      <p>Bu sayfa içeriği henüz eklenmedi.</p>
    </div>
  );
}
